<template>
  <div class="tx-12 align-items-center d-flex bd-l">
    asd
    <!-- <div v-if="params.f.flag == 1" class="pd-x-5 text">{{ params[params.f.field] }}</div> -->
    <!-- <div v-else-if="f.flag==2" class="pd-xs wd-100p">
      <div
        v-if="t[f.field]>0"
        style="color: #3f8b44"
        class="text-right o-w-b"
      >{{t[f.field] | formatMoney(2,'.',',')}}</div>
      <div
        v-else-if="t[f.field]==0"
        style="color: #99a6ad"
        class="text-right o-w-b"
      >{{t[f.field] | formatMoney(2,'.',',')}}</div>
      <div
        v-else-if="t[f.field]<0"
        style="color: #f44336"
        class="text-right o-w-b"
      >{{t[f.field] | formatMoney(2,'.',',')}}</div>
    </div>
    <div
      v-else-if="f.flag == 3"
      class="pd-x-5 text-muted"
    >{{ t[f.field] | moment("YYYY.MM.DD HH:mm") }}</div>
    <div v-else-if="f.flag == 11" class="pd-x-5 text">{{ showObj(t, f.field) }}</div>
    <div v-else-if="f.flag == 18" class="pd-x-5 pd-y-5 text-center wd-100p">
      <button
        v-if="t[f.field]>0"
        @click.stop="$emit('on-attach', t[f.field])"
        type="button"
        class="btn btn-xs btn-success btn-block pd-t-1 pd-b-1"
      >харах</button>
    </div> -->
    <!-- <div v-else-if="f.flag==17" class="pd-xs">
      <div v-if="t.pinnedUserCount>0">
        <a :title="t.pinnedUserCount+' хэрэглэгч идэвхитэй байна'" class="ff-ibm-plex">
          <b>{{t.pinnedUserCount}}</b>
          <sup>
            <i class="m-l-xs ivu-icon ivu-icon-ios-people" style="font-size: 12px;"></i>
          </sup>
        </a>
      </div>
    </div>
    <div
      v-else-if="f.flag == 19"
      class="pd-x-5 text tx-brand-01"
      @click.stop="$emit('show-detail', {obj: t[f.field], mode: 80})"
      role="button"
    >
      <template v-if="t[f.field].task != null && t[f.field].task != ''">
        <feather type="external-link" class="wd-15 ht-15"></feather>
        {{t[f.field]["task"]}}
      </template>
    </div>
    <div v-else-if="f.flag == 22" class="text-center wd-100p" @click.stop="updateField(f)">
      <feather
        role="button"
        :type="t[f.field] ? 'check-square':'square'"
        :class="`text-${t[f.field]?'success':'muted'}`"
      ></feather>
    </div>
    <div v-else-if="f.flag==25" class="text-center wd-100p">
      <span v-if="t.isTender">
        Төлсөн {{t.s16}}
      </span>
      <span v-else>
        Төлөөгүй
        <button
          v-if="t.isTender != true && hasPermission(['cashAdminAAA111', 'cashadmin', 'admin'])"
          type="button"
          class="ivu-btn ivu-btn-warning ivu-btn-small"
          @click="payByCash()"
        >Бэлнээр төлөх</button>
      </span>
    </div>
    <div v-else-if="f.flag==26" class="pd-xs text-center wd-100p">
      <div class="text-center">
        <feather v-if="t[f.field]=='true'|| t[f.field]=='1'" type="check-square"></feather>
        <feather v-else type="square"></feather>
      </div>
    </div>
    <template v-else-if="f.flag == 32">
      <template v-if="t.column != null">
        <div
          :id="`popover-reactive-${t.id}`"
          class="mg-x-5 progress ht-20 wd-100p"
          @click.stop="$emit('on-popover', t)"
        >
          <div
            :title="c.column"
            :key="i"
            v-for="(c, i) in projectStat.columns"
            :class="
                `progress-bar tx-10 ${
                  projectStat.columns.length > i + 1 ? 'bd-r' : ''
                } ${columnBg(t, i)}`
              "
            :style="{ width: (100 * t.columnOrd) / t.column.count + '%' }"
            role="progressbar"
          >
            <template v-if="isDateBefore(t.dueDate, nowDate)">
              <b-icon icon="alarm"></b-icon>
            </template>
            <template v-else>{{ c.column.charAt(0) }}</template>
          </div>
        </div>
      </template>
      <div v-else-if="t.isCompleted" class="pd-x-5 wd-100p">
        <feather type="check" style="font-size: 12px" class="tx-success"></feather>
      </div>
    </template>
    <div
      style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis; font-weight:700; "
      class="text-right ff-ibm-plex pd-xxs wd-100p"
      v-else-if="f.flag==33"
    >
      {{t[f.field]}}
    </div>
    <div v-else-if="f.flag == 34" class="pd-x-5 text-muted">{{ t[f.field] | moment("YYYY.MM.DD") }}</div>
    <div v-else-if="f.flag == 35" class="d-flex align-items-center pd-x-5 pd-y-2">
      <div class="avatar avatar-xs" style="min-width: 26px">
        <img    :src="t['user']['avator']" class="avatar-initial rounded-circle" />
      </div>
      <div class="mg-l-5">
        <div class="tx-11">{{ t["user"]["fullName"] }}</div>
        <div class="tx-8 text-muted">{{ t["user"]["position"] }}</div>
      </div>
    </div>
    <div v-else-if="f.flag==38" class="pd-x-5 text d-flex wd-100p justify-content-between">
      <template v-if="t.user != null">
        <div
          class="text-muted"
          style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis; cursor: pointer"
          :title="t.user.departName+' '+t.user.position"
        >
          {{t.user.departName}}
          <feather v-if="t.user.departName!=null" size="14" type="chevron-right"></feather>
          {{t.user.position}}
        </div>
      </template>
    </div>
    <div
      v-else-if="f.flag == 39"
      class="wd-100p text-truncate"
      @click.stop="$emit('on-user-info', t.user.id)"
    >
      <a v-if="t.user != null" :title="t.user.lastName + '-н ' + t.user.firstName">
        <img   
          :src="t.user.avator"
          class="m-r-xxs"
          style="border-radius: 5px; width: 16px; height: 16px"
        />
        {{t.user.fullName}}
      </a>
    </div>
    <div
      v-else-if="f.flag==40"
      style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis; cursor: pointer"
      class="pd-x-5 wd-100p text-truncate"
    >
      <span v-if="t.user != null">{{t.user.email}}</span>
    </div>
    <div
      v-else-if="f.flag==41"
      style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis; cursor: pointer;"
      class="pd-x-5 wd-100p text-truncate"
    >
      <member-point
        @on-show-point="$emit('on-show-point', { task: t, sumPoint: t.memberPoint  } )"
        :task="t"
        :sumPoint="t.memberPoint"
      />
    </div>
    <div v-else-if="f.flag == 43" class="wd-100p" @click.stop>
      <simple-uploader
        v-model="t[f.field]"
        :propBoxId="0"
        :propObjectId="'0'"
        :propObjectTypeId="t['objectTypeId']"
        @on-success="fileUploaded($event,f)"
        class="mg-t-3"
      >
        <div slot="trigger" class="wd-100p">
          <div class="btn-group wd-100p" v-if="t[f.field]>0">
            <button
              @click.stop="$emit('on-attach', t[f.field])"
              type="button"
              class="btn btn-xs btn-primary"
            >
              <feather type="paperclip"></feather>харах
            </button>
            <button @click.stop="fileRemoved(t,f)" type="button" class="btn btn-xs btn-danger">
              <feather type="x"></feather>хасах
            </button>
          </div>
          <div v-else class="btn-group wd-100p">
            <button type="button" class="btn btn-xs btn-outline-success">
              <feather type="upload"></feather>Компютероос
            </button>
            <button
              @click.stop="$emit('link-drive', {taskId: t.id, field: f.field })"
              type="button"
              class="btn btn-xs btn-outline-primary"
            >
              <feather type="archive"></feather>Драйваас
            </button>
          </div>
        </div>
      </simple-uploader>
    </div>
    <div v-else-if="f.flag == 45" class="wd-100p go-cell-ellps p-l-xs">
      <div @click="$emit('on-show-tags', t)" class="is-pointer">
        <template v-if="t.tagList != null">
          <template v-if="t.tagList.length>0">
            <span
              title="1+"
              v-if="t.tagList.length>1"
              :style="`margin-right: 2px; border-radius: 5px;color: white; text-transform: lowercase; padding: 0px 3px 2px 3px; font-size: 10px; background: gray`"
            >+{{t.tagList.length-1}}</span>
            <span
              :key="tgi"
              :title="tg.name"
              v-for="(tg, tgi) in t.tagList"
              :style="`margin-right: 2px; border-radius: 5px;color: white; text-transform: lowercase; padding: 0px 3px 2px 3px; font-size: 10px; background: ${tg.value}`"
            >{{tg.name}}</span>
          </template>
        </template>
        <div v-else title="Хавчуулах ?" class="text-center">
          <tag-icon size="12" class="m-t-sm"></tag-icon>
        </div>
      </div>
    </div>
    <div v-else-if="f.flag == 52" class="wd-100p" v-html="isInTime()"></div>
    <div v-else-if="f.flag == 54" class="wd-100p text-truncate pd-x-5">
      <template v-if="t.pinnedUsers!=undefined && t.pinnedUsers!=null && t.pinnedUsers.length">
        <div
          v-if="t.pinnedUsers.length>1"
          @click.stop="$emit('on-show-pinnedUsers')"
          :title="t.pinnedUserCount+' хэрэглэгч идэвхитэй байна'"
          class="img-group is-pointer"
        >
          <img   
            v-for="(pu,i) in t.pinnedUsers"
            :key="i"
            :src="pu.avator"
            class="img wd-20 ht-20 rounded-circle pd-0-f mg-l-0-f"
          />
        </div>
        <a
          v-else
          @click.stop="$emit('on-user-info', t.pinnedUsers[0].id)"
          :style="`color: ${getDocMyColor(t)}`"
        >{{t.pinnedUsers[0].fullName}}</a>
      </template>
    </div>
    <div v-else-if="f.flag == 55" class="wd-100p pd-xs"><span class="tx-info" v-show="t.i1==1">баталгаажсан</span><span class="tx-warning" v-show="t.i1==0">шинэ</span><span v-show="t.i1==2" class="tx-success">буцаан авсан</span><span class="tx-danger" v-show="t.i1==-1">цуцалсан</span></div> -->
    <!-- <div v-else class="text-muted">{{params.f.flag}}</div> -->
    <b-modal v-model="cashPayModal" title="Бэлнээр төлөх" ok-title="Батлах" cancel-title="Болих" @ok="confirmCashPay">
      <div class="form-group">
        <label>Тайлбар</label>
        <input v-model="cashPayDesc" type="text" class="form-control" />
      </div>
      <div v-if="$store.state.app.activeGroup.id == 6126" class="form-group mt-2">
        <label class="d-flex align-items-center" style="gap:8px;cursor:pointer">
          <input type="checkbox" v-model="cashPayIsSendMsg" />
          Мессеж илгээх эсэх
        </label>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
const moment = require("moment");
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";

export default {
  components: {
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    memberPoint: () => ({
      component: import(
        "@/components/task/list/components/memberPoint/memberPoint.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 5000
    })
  },
  // props: {
  //   f: {
  //     type: Object,
  //     default: () => {}
  //   },
  //   t: {
  //     type: Object,
  //     default: () => {}
  //   },
  //   projectStat: {
  //     type: Object,
  //     default: () => {}
  //   },
  //   nowDate: {
  //     type: String,
  //     default: () => ""
  //   },
  //   parentTask: {
  //     type: Object,
  //     default: () => {}
  //   }
  // },
  data() {
    return {
      cashPayModal: false,
      cashPayDesc: '',
      cashPayIsSendMsg: false,
    };
  },
  mounted() {},
  updated() {},
  methods: {
    refresh(params) {
      this.params = params.f;
      this.updateImage();
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    payByCash() {
      this.cashPayDesc = '';
      this.cashPayIsSendMsg = false;
      this.cashPayModal = true;
    },
    confirmCashPay() {
      request({
        api: { method: "post", url: "Payment/payByCash" },
        data: { invoiceId: this.t.id, desc: this.cashPayDesc, isSendMsg: this.cashPayIsSendMsg ? 1 : 0 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.$emit("on-update-field", {
            taskId: this.t.id,
            field: this.f,
            value: "",
            mode: 1
          });
        }
      });
    },
    columnBg(t, i) {
      let rv = "";
      if (t.columnOrd <= i + 1) {
        if (t.columnOrd == i + 1) {
          if (this.isDateBefore(t.dueDate, this.nowDate)) {
            rv = "bg-danger";
          } else {
            rv = "bg-warning-light";
          }
        } else {
          rv = "bg-white text-muted";
        }
      } else {
        rv = "bg-success-light";
      }
      return rv;
    },
    isDateBefore(d1, d2) {
      return moment(d1).isBefore(d2);
    },
    showObj(t, f) {
      let arr = f.split(".");
      return t[arr[0]][arr[1]];
    },
    fileUploaded(e, field) {
      // field.uv = false;
      // this.t[this.f.key] = e.uploadedName;
      // this.t[this.f.field] = e.uploadedAttachmentId;
      // field.cstmFld1 = e.uploadedUrl;
      // this.featherReplace();
      //this.$emit("on-update-field", { taskId: this.t.id, field: { field: field.field }, value: e.uploadedAttachmentId, mode: 2 });
      this.$emit("on-update-field", {
        taskId: this.t.id,
        field: { field: field.field },
        value: e.uploadedAttachmentId,
        mode: 22
      });
    },
    fileRemoved(t, field) {
      // this.t[field.field]=null;
      // this.t[field.key]='';
      //if(this.parentTask.im!=null && this.parentTask.im.pinIs){
      this.$emit("on-update-field", {
        taskId: this.t.id,
        field: { field: field.field },
        value: null,
        mode: 2
      });
      // }else{
      //   this.$bvToast.toast('Үйлдлийг гүйцэтгэх боломжгүй', { title: "Мэдэгдэл", autoHideDelay: 3000, appendToast: false, variant: "warning", toaster: "b-toaster-bottom-left"});
      // }
      //this.featherReplace();
    },
    infoBuilder(v) {
      if (v == null) {
        return "";
      } else if (v.length <= 0) {
        return "";
      } else {
        return v;
      }
    },
    updateField(f) {
      if (hasOneOf(f.key.split(","), this.$store.state.user.access)) {
        this.$emit("on-update-field", {
          taskId: this.t.id,
          field: { field: f.field },
          value: this.t[f.field],
          mode: 0
        });
      } else {
        this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй22", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: false,
          variant: "warning",
          toaster: "b-toaster-bottom-left"
        });
      }
    },
    isInTime() {
      let rv = "";
      if (this.t["dueStartDate"] > this.nowDate) {
        rv = `<span class="badge badge-secondary">Хурал эхлэх | ${moment(
          this.t["dueStartDate"]
        ).format("MM-сар DD-н HHц:mmм")}</span>`;
      } else {
        if (this.t["dueDate"] > this.nowDate) {
          rv = '<span class="badge badge-warning">Хурал үргэлжилж байна</span>';
        } else {
          rv = `<span class="badge badge-success">Дууссан | ${moment(
            this.t["dueDate"]
          ).format("MM-сар DD-н HHц:mmм")}</span>`;
        }
      }
      return rv;
    },
    calculateRangeIsAlert(d1, d2) {
      return moment(d1).isBefore(d2);
    },
    getDocMyColor(t) {
      let rv = "rgb(158, 158, 158)";
      if (this.$store.state.user.userId == t.pinnedUsers[0].userId) {
        if (t.column != null) {
          if (this.calculateRangeIsAlert(t.dueDate, this.nowDate)) {
            if (t.objectTypeId == 157 && t.i1 == 1) {
              rv = "red";
            } else {
              rv = "#57a3f3";
            }
          }
        } else if (t.isCompleted) {
          rv = "green";
        }
      }
      return rv;
    }
  }
};
</script>
